<section>
  <bb-page-zero *ngIf="isPage(0)|async"></bb-page-zero>
  <bb-page-one *ngIf="isPage(1)|async"></bb-page-one>
  <bb-page-two *ngIf="isPage(2)|async"></bb-page-two>
</section>
